import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import './style.css';
const TermsAndConditions = () => {
  const { t ,i18n} = useTranslation();
console.log('>>>>>',i18n.language)

  return (<div className="container mt-5">
   {i18n.language === "sr"? <div className="terms-conditions">

      <h2>Uslovi i pravila korišćenja</h2>
      <hr/>
      <div>
        <p>
          Korišćenjem servisa PointSnaps korisnik prihvata sve Uslove i pravila servisa i vlasnika servisa.
      </p>
        <p>
          Osnovna namena servisa PointSnaps je prikupljanje relevantnih podataka i informacija sa lica mesta, odnosno terena, o našem gradu, uslovima životne sredine, određenim sferama društvenog života, komunalnim uslugama i drugim relevantnim dešavanjima.
      </p>
        <p>
          Preko servisa PointSnaps prikupljaju se i dele određeni podaci sa terena od strane korisnika servisa, na osnovu kojih administratori servisa i krajnji korisnik servisa ( korisnik licence) raspolaže raznim sadržajima i podacima koji se odnose na konkretne oblasti ( npr. uslovi životne sredine, ptičija gnezda, reoni pod zaštićenim biljnim vrstama, određene sfere društvenog života grada, komunalne usluge, druga dešavanja u gradu i slično).
      </p>
        <p>
          Servis PointSnaps je dostupan korisnicima nakon izvršene registracije od strane kompanije, krajnjeg korisnika ( korisnika licence) ili korisnika servisa.
          Prilikom registracije kompanija, krajnji korisnik ( korisnik licence) i korisnik registruju e-mail adresu, naziv kompanije, ime i prezime. Nakon registrovanog naloga korisnik može slati sadržaj, fotografije ili druge informacije.
          Servis omogućava da se prilikom korišćenja automatski izvrši detekcija lokacije korisnika. Korisnik može opciono izabrati da li dodaje neki opis uz sadržaj, fotografije i druge informacije, koji potom neograničeno koriste administratori servisa, odnosno konkretan krajnji korisnik ( korisnik licence).
        </p>
        <p>
          Prilikom slanja sadržaja, fotografija i drugih informacija na servis PointSnaps korisnik servisa daje i izražava svoju saglasnost i nedvosmisleno pristaje da se navedeni sadržaj, fotografije i druge informacije, kao i svako dalje raspolaganje sadržajem, fotografijama i drugim informacijama, od trenutka slanja na servis PointSnaps, smatraju isključivom svojinom servisa PointSnaps.
        </p>
        <p>
          Korisnik servisa koji je sadržaj učinio dostupnim korišćenjem servisa, slanjem i postavljanjem sadržaja, fotografije i druge informacije to je učinio dobrovoljno, bez naknade ili druge obaveze i nema prava da po tom osnovu nešto potražuje, niti da se na osnovu toga, poziva na autorsko pravo prema vlasniku servisa, kao ni prema krajnjem korisniku ( korisniku licence ) ili kompaniji koja je u skladu sa ugovornim odnosom jedan od krajnjih korisnika. Postavljeni sadržaj, fotografija i druga informacija na servisu mogu biti uklonjeni ili modifikovani od strane korisnika servisa koji je postavio konkretan sadržaj, fotografiju i drugu informaciju ukoliko smatra da isti nije adekvatan.
        </p>
        <p>
          Određene sadržaje kojima se zloupotrebljavaju prava trećih lica, narušavaju ili ugrožavaju prava servisa PointSnaps, administratori servisa su ovlašćeni da uklone ili onemoguće njihovu dalju distribuciju ili vidljivost, bez prethodnog obaveštenja i bez odobrenja korisnika.
          Servis PointSnaps ni pod kojim uslovima nije odgovoran za sadržaje koje korisnik postavlja preko servisa.
        </p>
        <p>
          Prilikom korišćenja servisa i registracije naloga registruju se lični podaci korisnika u vidu naziva kompanije, imena, prezimena, e-mail, fotografije na korisničkom nalogu i vrši se automatska detekcija lokacije korisnika. Prilikom registracije podaci o ličnosti se prikupljaju u svrhe registrovanja ili potvrde autentičnosti čime korisnici dozvoljavaju ovom servisu da ih identifikuje i da pristupe servisu PointSnaps.
        </p>
        <p>
          Servis nije odgovoran za gubitak, krađu lozinki korisnika ili njihovu neovlašćenu upotrebu. Korisnik je saglasan da odmah obavesti servis PointSnaps ukoliko dođe do neovlašćene upotrebe lozinke, naloga ili bilo kakvog narušavanja bezbednosti.
        </p>
        <p>
          Ukoliko korisnik posumnja u neautorizovano korišćenje korisničkog imena ili lozinke, korisnik je odgovoran za korišćenje njegovog korisničkog imena i lozinke do trenutka dok ne obavesti servis PointSnaps o sumnji o neautorizovanom korišćenju. Korisnik je odgovoran i za sve nedozvoljene aktivnosti  izvršene pod njegovim korisničkim imenom i lozinkom.
        </p>
        <p>
          Korisnik servisa prihvata da koristi servis PointSnaps na sopstvenu odgovornost. Internet je internacionalna računarska mreža na koju servis PointSnaps nema uticaja i koji nema mogućnost direktno da kontroliše. Servis PointSnaps ne daje nikakve garancije i ne preuzima nikakvu odgovornost za eventualnu štetu koju korisnik pretrpi prilikom korišćenja servisa, niti će biti odgovoran za zahteve koje ističu treća lica. Korisnik servisa je dužan da servis PointSnaps koristi u skladu sa svim važećim pravnim propisima.
        </p>
        <p>
          Servis PointSnaps je u potpunosti posvećen principima zaštite ličnih podataka svih korisnika i na najvišem nivou posvećen poštovanju prava i zakonskih odredbi koje se odnose na zaštitu ličnih podataka koji su u primeni u Republici Srbiji, a u skladu sa odredbama Zakona o zaštiti podataka o ličnosti.
        </p>
        <p>
          Lični podaci koje korisnik servisa PointSnaps učini dostupnim prilikom registracije naloga popunjavanjem traženih polja, kao i korišćenjem servisa, neće biti ni na koji način ugroženi i sa njima se postupa sa najvećim merama opreza. Sa ličnim podacima registrovanih korisnika servisa raspolaže se isključivo u strogo kontrolisanim uslovima i svi lični podaci korisnika servisa zaštićeni su u skladu sa zakonom. Obrada podataka se vrši na odgovarajući način i preduzimaju mere zaštite kako bi se sprečio neovlašćeni pristup, otkrivanje, modifikacija ili neovlašćeno uništavanje podataka. Lični podaci korisnika servisa se ne dele na bilo koji način, niti prosleđuju bilo kom trećem licu ili kompanijii, a koje bi korisnika mogle identifikovati na bilo koji način          ( informacije kao što su ime, prezime, naziv kompanije, e-mail adresa i dr. ), niti bilo koja druga informacija na osnovu koje bi korisnik servisa mogao biti identifikovan. Zaštita privatnosti i ličnih podataka korisnika servisa je od ključne važnosti.
        </p>
        <p>
          Servis PointSnaps je dostupan korisnicima, uz ograničenje za osobe do uzrasta od 13.godina starosti, kojima korišćenje servisa nije dozvoljeno.
        </p>
        <p>
          Servis PointSnaps je dostupan za korisnike koji servis koriste u dobroj nameri, dele sadržaj, fotografije i druge informacije koje su suštinski važne, čime doprinose daljem razvoju i bogatijem sadržaju servisa.
          Korisnik servis koristi besplatno, dok se sa kompanijom kao krajnjim korisnikom ( korisnikom licence) uslovi definišu ugovorom o korišćenju licence.
          Registracijom i korišćenjem korisnik servisa PointSnaps saglasno potvrđuje da sadržaj, fotografije i druge informacije koje je učinio dostupnim slanjem i postavljanjem na servis, mogu da se koriste u svrhu za koju je servis PointSnaps namenjen.
          Korisnik neće smatrati servis PointSnaps odgovornim za bilo kakve greške u radu servisa, brisanje podataka, otežanja u radu servisa ili kašnjenja u prenosu podataka.
        </p>
        <ul>
          <span>Ukoliko želite da delite sadržaj preko servisa i korisnik ste servisa PointSnaps dužni ste da: </span>
          <li>- se pridržavate ovih Uslova i pravila, da ih ne kršite ili ugrožavate na bilo koji način; </li>
          <li>- ne kršite zakonske propise i ne delite sadržaj, fotografije i druge informacije koji se mogu na bilo koji način smatrati štetnim ili protivzakonitim;</li>
          <li>- ne delite sadržaj koji je neistinit, netačan, diskriminatoran ili lažan na bilo koji način;</li>
          <li>- ne delite sadržaj koji narušava bilo čija prava, uključujući intelektualnu svojinu i autorska prava.</li>
        </ul>
        <p>
          Korisnik ne sme koristiti servis na način koji prouzrokuje štetu ili ugrožava interese ili sigurnost servisa ili trećih lica na bilo koji način. Zloupotreba servisa nije dozvoljena.
        </p>
        <p>
          Korisnik servisa se saglašava i garantuje da materijali koje šalje i postavlja preko servisa ne krše relevantne zakonske propise, a naročito prava intelektualne svojine, privatnost trećih lica, krivične propise, zakon o elektronskim komunikacijama, zakon o zaštiti podataka o ličnosti i sve druge relevantne zakonske propise Republike Srbije.
          U slučaju da korisnik servisa postupa suprotno ovoj odredbi ili na bilo koji način suprotno važećim, zakonskim propisima, servis PointSnaps se neće smatrati odgovornim, već je odgovornost isključivo na korisniku.
        </p>
        <p>
          Vlasnik servisa se u potpunosti odriče svake odgovornosti i garancije bez obzira da li je podrazumevana, uključujući podobnost za određenu svrhu i dr., (i) koja na bilo koji način može proizaći iz korišćenja ili je vezana za korišćenje servisa (ii) za bilo koje radnje korisnika servisa upotrebom ili zloupotrebom sadržaja servisa, te za (iii) bilo kakvu štetu koja može nastati korisniku servisa ili bilo kojoj trećoj strani u vezi s upotrebom ili zloupotrebom korišćenja sadržaja servisa, fotografije i bilo koje druge informacije.
        </p>
        <p>
          Korisnik se slaže da vlasnik servisa i servis PointSnaps ne mogu biti odgovorni za bilo kakvu štetu koja može nastati korišćenjem servisa, postavljanjem sadržaja, ograničavanjem ili ukidanjem korišćenja servisa iz bilo kog razloga.
        </p>
        <p>
          Servis je osmišljen radi unapređenja i poboljšanja bolje informisanosti u raznim oblastima društvenog života, uslovima životne sredine, kulturnim sferama, kao i komunalnim delatnostima.
        </p>
        <p>
          Servis zadržava pravo da sa vremena na vreme menja ove Uslove i pravila. Korisnici servisa će blagovremeno biti obavešteni o svim promenama Uslova i pravila. Objavljivanjem izmenjenih Uslova i pravila, novi Uslovi obavezuju korisnika servisa. Smatraće se da je korisnik servisa saglasan sa novim Uslovima i pravilima ukoliko korisnik servisa nastavi da koristi servis. Jednom izmenjeni i objavljeni Uslovi i pravila nakon stupanja na snagu, biće obavezujući za sve korisnike servisa.
          Servis je koncipiran “kao takav” i nema garancije da će konstantno funkcionisati bez greške, ometanja ili nesavršenosti, uz napomenu da se radi na stalnom unapređenju servisa u svim oblastima u kojima ima namenu.
          
        </p>
      </div>
    </div>:
    <div className="terms-conditions">
        <h2>Terms & Conditions of services</h2>
      <hr/>
      <div>
        <p>
        By using the services of PointSnaps the user agrees to be bound by all the Terms and Conditions
         of the services and the service owner.
        </p>
        <p>
        The main purpose of the PointSnaps service is the collection of the relevant data and
        information on the spot, i.e. in the field, about our city, environmental issues, specific areas of
        the social life, utility services and other relevant areas of interest.
       </p>
        <p>
        Over PointSnaps service, the service users collect and share specific data collected on the field,
        which provide the service administrators and the end-user (a licensee) with various information
        related to specific areas (eg. environmental issues, bird nests, regions with protected plant
        species, certain spheres of the social life etc.).
        </p>
        <p>
        PointSnaps service becomes available to the users after the registration has been completed by
        a company, an end-user (a licensee) or a service user.
        </p>
        <p>
        Registration requires a company, the end-user (a licensee) or a user to register an email
        address, company’s name, first name and last name. After the account has been registered the
        user can send content, photos or other information.
        </p>
        <p>
        Service enables automatic detection of the user’s location. The user can choose to accompany
        their content, photo or other information with the description, which is afterwards
        unrestrictedly used by the service administrators, i.e. a specific end-user (a licensee).
        </p>
        <p>
        When sending content, photos and other information to the PointSnaps service, the service
        user unequivocally agrees that the sent content, photos and other information as well as any
        further use of this content, photos and information are, from the moment of sending, exclusive
        property of the PointSnaps service.
        </p>
        <p>
        The service user who has made the content available using this service, by sending or posting
        content, photos and other information, has done it voluntarily, without any compensation or
        any other fee and has no right to make any claims to the service owner nor to claim copyright
        from the service owner, end-user (a licensee ) nor the company which is by the contract
        considered as one of the end-users. Content, photo or any other information posted on the
        service, can be removed or modified by the service user who has posted the specific content,
        photo or other information if they consider it inadequate.
        </p>
        <p>
        Service administrators are authorized, without prior notice or the user’s approval, to remove or
        terminate the further distribution or visibility of the specific content which misuses the rights of
        the third parties, which damages or infringes the rights of the PointSnaps service.
        </p>
        <p>
        PointSnaps service is under no circumstances responsible for the content posted by the user
        over the service.
        </p>
        <p>
        During the service and account registration, the personal information of the user is registered in
        the form of the company’s name, first name, last name, email address, photo on the user
        account and automatic detection of the user’s location is conducted. During the use of the
        service and the registration, the personal information is collected for the registration and
        authentication purposes; in this way users allow the service to identify them and approve their
        access to the PointSnaps service.
        </p>
        <p>
        The service is not responsible for the loss or theft of a password or their unauthorized use. The
        user agrees to inform PointSnaps immediately in case of any unauthorized use of a password,
        account or any other security breach.
        </p>
        <p>
        If a user suspects unauthorized use of the username or password, the user is responsible for the
        use of their username and password until the moment the PointSnaps service is notified of the
        suspected unauthorized use. The user is also responsible for all illegal activities performed
        under his/her username and password.
        </p>
        <p>
        The service users agree to use the PointSnaps service at their own risk. The Internet is an
        international computer network which is beyond PointSnaps influence and direct control.
        PointSnaps Service gives no guarantees and assumes no liability for any damage suffered by the
        user while using the service, nor will it be responsible for claims made by third parties. The
        service user is obliged to use the PointSnaps service by all the applicable legal regulations.
        </p>
        <p>
        PointSnaps is fully committed to the principles of personal data protection of all users and, at
        the highest level, is committed to respecting the rights and legal provisions on personal data
        protection applicable in the Republic of Serbia, by the provisions of the Law on Personal Data
        Protection.
        </p>
        <p>
        Personal data which a PointSnaps user makes available when registering an account by filling in
        the required fields and by using the service will not be compromised in any way and will be
        handled with utmost care. The personal data of the registered service users are managed under
        strictly controlled conditions and all personal data of the service users are protected by the law.
        Data processing is carried out appropriately with all the security measures implemented to
        prevent unauthorized access, disclosure, modification or unauthorized destruction of data. The
        personal information of the service users is not shared in any way, nor forwarded to any thirdparty or company, which could identify the user in any way (information such as name,
        company name, e-mail address, etc.). ), nor is any other information that identifies the service
        user. The protection of privacy and personal information of service users is of crucial
        importance.
        </p>
        <p>
        PointSnaps Service is available to the users, with the restrictions for people under 13, who are
        not allowed to use the service.  
        </p>
        <p>
        PointSnaps Service is available to the users who use the Service in good faith, share content,
        photos and other information which are essential, thus contributing to the further
        development and more versatile content of the service.
        </p>
        <p>
        The user uses the service for free, while with the company as the end-user (licensee), the terms
        are defined by the license agreement.
        </p>
        <p>By registering to and using the service, the PointSnaps user agrees that the content, photos,
        and other information made available by sending and posting to the service may be used for
        the purpose for which the PointSnaps service is intended.</p>
        <p>A user will not hold PointSnaps Service responsible for any errors in the service operation,
        deletion of data, impediments to the operation of the service or delays in data transmission.</p>
        <ul>
          <span>If you want to use this service to share content as a PointSnaps user you are required: </span>
          <li>- to abide by these Terms and Conditions, not to violate or compromise them in any way;</li>
          <li>- not to violate any legal requirements or share content, photos and other information that may
           in any way be considered harmful or illegal;</li>
          <li>- not to share content that is untrue, inaccurate, discriminatory or fraudulent in any way;</li>
          <li>- not to share content that violates anyone's rights, including intellectual property and
           copyright.</li>
        </ul>
        <p>
        The user must not use the service in any way which causes damage or jeopardizes the interests
         or the safety of the service or the third parties in any way.
        </p>
        <p>
        The misuse of the service is not allowed.
        </p>
        <p>
        The service user agrees and guarantees that the materials sent and posted over the service do
        not violate relevant legal regulations, especially intellectual property rights, the privacy of third
        parties, criminal regulations, the Law on electronic communication, the Law on personal data
        protection and all other relevant legal regulations in the Republic of Serbia.
        </p>
        <p>
        If the service user acts contrary to this provision or in any other way contrary to the applicable
        legal regulations, PointSnaps service is not to be considered responsible, but the responsibility
        lies solely on the user.
        </p>
        <p>
        The service owner completely disclaims any responsibility and guaranty regardless of whether it
        is implied, including aptness etc for the particular purpose (i) which may in any way arise from
        or be associated with the use of the service (ii) for any actions of the service user in terms of
        using or misusing the service content, and (iii) any harm that may occur to the service user or
        any third party in relation with the use or misuse of the service content, photo or any other
        information.
        </p>
        <p>
        The user agrees that the service owner and Point Snaps service cannot be held responsible for
        any kind of damage which can result from the use of service, posting of content, restricting or
        terminating the service use for any reason.
        </p>
        <p>
        The service is designed to enhance and improve the availability of information from the various
        areas of social life, environmental issues, cultural sphere and utility services.
        </p>
        <p>
        The Service reserves the right to change these Terms and Conditions from time to time. Service
        users will be notified promptly of any changes to the Terms and Conditions. By publishing the
        amended Terms and Conditions, the new Terms become binding on the service user. The
        service user will be deemed to agree to the new Terms and Conditions if the service user
        continues to use the service. Once amended and published, the Terms and Conditions will be
        binding on all the users of the service.
        </p>
        <p>
        The service is designed "as such" and there is no guarantee that it will function constantly
      without error, interference or imperfection, noting that we are working on the continuous
      improvement of the service in all the areas it is intended for.
              </p>
      </div>
      </div>}

  </div>)
}

export default TermsAndConditions;




// WEBPACK FOOTER //
// ./src/components/policy/terms.js